import { render, staticRenderFns } from "./TabControles.vue?vue&type=template&id=0df9b23c&"
import script from "./TabControles.vue?vue&type=script&lang=js&"
export * from "./TabControles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports